var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16px",
  height: "17px",
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "2-01") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2-01",
  fill: "#7D7D7D",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5,8.5 L15,8.5 C14.9521957,11.8363687 12.5561379,14.6752042 9.27519694,15.2827138 C5.99425595,15.8902233 2.74060503,14.0975059 1.5013816,10.9994474 C0.262158168,7.90138879 1.38189342,4.35931697 4.17671933,2.53651974 C6.97154524,0.713722503 10.6644391,1.11697732 13,3.5 C14.3067345,4.83328912 15.0267463,6.6333186 15,8.5 L16,8.5 C16,4.081722 12.418278,0.5 8,0.5 C3.581722,0.5 3.55271368e-15,4.081722 3.55271368e-15,8.5 C3.55271368e-15,12.918278 3.581722,16.5 8,16.5 C12.418278,16.5 16,12.918278 16,8.5 L15.5,8.5 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "11.44 11.04 9.05 8.65 9 8.6 9 4.5 8 4.5 8 9.01 8.35 9.36 10.73 11.74 11.44 11.04"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock2);
export default ForwardRef;